<div class="cliente-list">
    <table class="table table-striped table-hover table-bordered" [id]="idDataTable">
        <thead>
            <tr>
                <th class="col-options"></th>
                <th class="col-codigo-integracao-erp">Código ERP</th>
                <th class="col-nome">Nome</th>
                <th class="col-nome-fantasia">Nome Fantasia</th>
                <th class="col-cnpj-cpf">CNPJ / CPF</th>
                <th class="col-nome-representante">Representante</th>
                <th class="col-tipo-pessoa text-center">Tipo</th>
                <th class="col-cadastro text-center">Cadastro</th>
                <th class="col-situacao text-center">Situação</th>
                <th class="col-origem">Origem</th>
                <th class="col-canal-midia-social">Canal Mídia Social</th>                
                <th class="col-nome-campanha">Campanha de Origem</th>
                <th class="col-nome-campanha">Campanha de Aquisição</th>
                <th class="col-status-analise-financeira text-center">Análise Financeira</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td colspan="14" class="text-center">
                    {{quantidadeClientes | decimalFormat: 1:0:0}} cliente(s)
                </td>
            </tr>        
    </table>
</div>

<!-- Container para criar dinamicamente os badges dos tipos das pessoas -->
<ng-template #pessoaTipoBadgeContainer></ng-template>

<!-- Container para criar dinamicamente os badges dos status da análises financeira -->
<ng-template #analiseFinanceiraStatusBadgeContainer></ng-template>

<!-- Modal para concluir a Análise Financeira do Cliente -->
<sgt-cliente-analise-financeira-concluir-modal
    #analiseFinanceiraConcluirModal
    (afterConcluir)="onAfterConcluirAnaliseFinanceira()">
</sgt-cliente-analise-financeira-concluir-modal>

<!-- Modal para revisar a Análise Financeira do Cliente -->
<sgt-cliente-analise-financeira-revisar-modal
    #analiseFinanceiraRevisarModal
    (afterRevisar)="onAfterRevisarAnaliseFinanceira()">
</sgt-cliente-analise-financeira-revisar-modal>

<!-- Modal para congelar um cliente -->
<sgt-cliente-carteira-congelar-modal
    #clienteCarteiraCongelarModal
    [isRepresentante]="isRepresentante"
    (afterCongelar)="refresh()">
</sgt-cliente-carteira-congelar-modal>

<!-- Modal para pré-baixar um cliente -->
<sgt-cliente-carteira-prebaixar-modal
    #clienteCarteiraPreBaixarModal
    [isRepresentante]="isRepresentante"
    (afterInsertPreBaixa)="refresh()"
    (afterEditPreBaixa)="refresh()">
</sgt-cliente-carteira-prebaixar-modal>

<!-- Modal para baixar um cliente -->
<sgt-cliente-carteira-baixar-modal
    #clienteCarteiraBaixarModal
    [isRepresentante]="isRepresentante"
    subTitleInsert="Informe o motivo da baixa deste cliente"
    (afterInsertBaixa)="refresh()"
    (afterEditBaixa)="refresh()">
</sgt-cliente-carteira-baixar-modal>

<!-- Negócio Form Insert -->
<sgt-negocio-form-insert-modal
    #formInsertModal> <!--     (afterCreateOportunidade)="onAfterCreateOportunidade($event)" -->
</sgt-negocio-form-insert-modal>

<!-- Form -->
<!-- <sgt-negocio-oportunidade-form-modal
    #formOportunidadeModal>
</sgt-negocio-oportunidade-form-modal> -->